import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type CalloutCardConfig } from './callout-card.types';

@Component({
  selector: 'app-callout-card',
  templateUrl: './callout-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic, NgClass],
})
export class CalloutCard {
  readonly config = input.required<CalloutCardConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected readonly titleConfig = computed(() => ({
    ...this.config().title,
    tag: 'h3' as const,
    cssVarPrefix: 'calloutcard',
  }));

  protected readonly primaryButtonConfig = computed(() => {
    const button = this.config().primaryButton;
    return {
      ...button,
      severity: button.severity ?? 'secondary',
      fluid: button.fluid ?? true,
      rounded: button.rounded ?? true,
    };
  });

  protected readonly secondaryButtonConfig = computed(() => {
    const button = this.config().secondaryButton;
    if (!button) return null;
    return {
      ...button,
      severity: button.severity ?? 'secondary',
      fluid: button.fluid ?? true,
      rounded: button.rounded ?? true,
    };
  });

  protected onButtonClick(event: DynamicAction): void {
    this.action.emit(event);
  }

  protected onDismiss(): void {
    this.action.emit(this.config().dismissAction ?? { id: 'dismiss' });
  }
}
